<template>
  <el-checkbox-group
    ref="checkboxGroup"
    v-model="selectValue"
    :border-size="borderSize"
    :button-size="buttonSize"
    v-bind="$attrs"
    :class="computedClass"
    @change="change"
    @input="input"
  >
    <slot />
  </el-checkbox-group>
</template>
<script>
import ElCheckboxGroup from 'vue-xpc/src/element-ui/packages/checkbox/src/checkbox-group.vue';

export default {
  name: 'RtCheckboxGroup',
  components: {
    ElCheckboxGroup
  },
  props: {
    value: Array,
    // 带边框多选尺寸，默认medium，可选值small、medium、large
    borderSize: {
      type: String,
      default: 'medium'
    },
    // 按钮用法多选尺寸，默认medium，可选值small、medium、large
    buttonSize: {
      type: String,
      default: 'medium'
    }
  },
  data () {
    return {
      selectValue: this.value,
      checkboxType: 'round'
    };
  },
  computed: {
    computedClass () {
      let classList = ['rt-checkbox-group'];
      if (this.borderSize) {
        classList.push(`rt-xpc-checkbox-bordered-${this.borderSize}`);
      }
      if (this.buttonSize) {
        classList.push(`rt-xpc-checkbox-button-${this.buttonSize}`);
      }
      if (this.checkboxType) {
        classList.push(`rt-xpc-checkbox-type-${this.checkboxType}`);
      }
      return classList;
    }
  },
  watch: {
    value (val) {
      this.selectValue = val;
    }
  },
  mounted () {
    let className =
      this.$refs.checkboxGroup &&
      this.$refs.checkboxGroup.$children &&
      this.$refs.checkboxGroup.$children[0] &&
      this.$refs.checkboxGroup.$children[0].$el.className;

    if (className.includes('is-bordered')) {
      this.checkboxType = 'border';
    } else if (className.includes('el-checkbox-button')) {
      this.checkboxType = 'button';
    } else {
      this.checkboxType = 'round';
    }
  },
  methods: {
    change (val) {
      this.$emit('change', val);
    },
    input (val) {
      this.$emit('input', val);
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtCheckboxGroup.vue?4a0af13e